import React, { Component } from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

import { name, storageKeys } from 'settings';
import { BackImage, StorageHandler, LanguageSelect, ContentHeader } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logo from 'assets/images/logo/logo_white.png';

export default class LoungeView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: {
        message1: {
          userName: 'Hank',
          text: 'Hey Everyone!',
          date: '9:15 AM',
        },
        message2: {
          userName: 'Paula',
          text: 'Hello Hank',
          date: '9:16 AM',
        },
      },
      newMessage: {
        userName: 'Me',
        text: '',
        date: '9:15 AM',
      },
    };

    //  this.getMessages();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    // TODO
    // stuff
  }

  componentDidMount() {
    this.getDate();
  }

  getDate() {
    const newDate = new Date().getTime().toLocaleString();

    this.setState({ messages: { date: newDate } });
  }

  getMessages() {
    const messages = Object.keys(this.state.messages).map(message => (
      <li key={message.id}>
        <div className="chatUser">
          {message.userName}
        </div>
        <div className="message">
          {message.text}
        </div>
        <div className="time">
          {message.date}
        </div>
      </li>
    ));
    return (messages);
    // return (
    //   <div className="message__Wrapper">
    //     <ul>
    //       {this.state.messages.map(message => (
    //         <li key={message.id}>
    //           <div className="chatUser">
    //             {message.userName}
    //           </div>
    //           <div className="message">
    //             {message.text}
    //           </div>
    //           <div className="time">
    //             {message.date}
    //           </div>
    //         </li>))}
    //     </ul>
    //   </div>
    // );
  }

  handleChange(event) {
    this.setState({ newMessage: event.target.value });
  }

  handleSubmit(event) {
    alert(`A name was submitted: ${this.state.newMessage.text}`);
    this.sendMessage();
    // this.getMessages();
    event.preventDefault();
  }

  // sendMessage(mesg) {
  //   const newTime = this.getDate();

  //   this.setState({ newMessage: { userName: 'Me' } });
  //   this.setState({ newMessage: { text: mesg } });
  //   this.setState({ newMessage: { date: newTime } });

  // update the state object
  // this.state.messages[`message-${timestamp}`] = newMessage;
  //   // set the state
  // this.setState({ messages: this.state.messages });
  // this.addMessage(mesg);
  //   // update the state object
  //   this.state.messages['message-' + timestamp ] = newMessage;
  //   // set the state
  //   this.setState({ messages : this.state.messages });

  // <div className="thisUserChatMessage">
  //   <div className="chatUser">
  //     Me
  //   </div>
  //   <div className="message">
  //     {this.state.message}
  //   </div>
  //   <div className="time">
  //     {this.state.date}
  //   </div>
  // </div>
  // <ul className="messages__Wrapper">
  //   {this.state.messages.map(message => (
  //     <li key={message.id}>
  //       <div>
  //         {message.userName}
  //       </div>
  //       <div>
  //         {message.text}
  //       </div>
  //       <div>
  //         {message.date}
  //       </div>
  //     </li>
  //        ))}
  // </ul>
  // }

  // addMessage(newMessage) {
  //   // create a unike key for each new fruit item
  //   const timestamp = (new Date()).getTime();
  //   // update the state object
  //   this.state.messages[`message-${timestamp}`] = newMessage;
  //   // set the state
  //   this.setState({ messages: this.state.messages });


  // }


  render() {
    return (
      <div className="loungeView">
        <div className="gradient" />
        <div className="bg" />

        <div className="lounge__Wrapper">
          <ContentHeader
            header="Network Lounge"
            subtitle="Take a breather from all the content and booth visits, to join the conversation or search for friends and attendees to chat one to one."
            icon="handshake"
          />

					<div className="schedule">
							<h3>Today&apos;s Program</h3>
							<br />
						<Link to="/main/breakout-sessions">
							<h3>Breakout Sessions</h3>
							<Link to="/main/breakout-sessions/class/101">
								<p><b>Road Trippin&apos; - <br />an American Classic</b><br />11:00am - 11:30am</p>
							</Link>
							<Link to="/main/breakout-sessions/class/101">
								<p><b>Travel Insurance Matters</b><br />11:15am - 11:40am</p>
							</Link>
						</Link>
						<Link to="/main/exhibition">
							<h3>Showground News</h3>
						</Link>
						<Link to="/main/exhibition/101">
							<p><b> L.A.&apos;s Corona Proof Travel</b></p>
						</Link>
						<Link to="/main/exhibition/101">
							<p><b>Anaheim Travel Smart</b></p>
						</Link>
						<Link to="/main/network-lounge">
							<h3>Network Lounge</h3>
							<p><b>Live Chat</b><br />1pm - 6:30pm</p>
						</Link>

					</div>

          <div className="chat__Holder">
            <div className="chat__Wrapper">

              <div className="messages__Wrapper">
                {/* <ul> */}
                <div className="chatMessage">
                  <div className="chatUser">
                    Hank
                  </div>
                  <div className="message">
                    Hey everyone!
                  </div>
                  <div className="time">
                    09:34 AM
                  </div>
                </div>
                <div className="thisUserChatMessage">
                  <div className="chatUser">
                    Paula
                  </div>
                  <div className="message">
                    Hey Hank!
                  </div>
                  <div className="time">
                    09:34 AM
                  </div>
                </div>
                <div className="thisUserChatMessage">
                  <div className="chatUser">
                    Paula
                  </div>
                  <div className="message">
                    I was wondering if anybody is interested in my ideas.
                  </div>
                  <div className="time">
                    09:35 AM
                  </div>
                </div>
                <div className="chatMessage">
                  <div className="chatUser">
                    Sarah
                  </div>
                  <div className="message">
                    Yes of course, let's connect!
                  </div>
                  <div className="time">
                    09:35 AM
                  </div>
                </div>
                <div className="chatMessage">
                  <div className="chatUser">
                    Hank
                  </div>
                  <div className="message">
                    Sounds like a great plan Sarah.
                  </div>
                  <div className="time">
                    09:35 AM
                  </div>
                </div>
                {/* {this.getMessages()} */}
                {/* </ul> */}
              </div>


              <div className="chat__Input">
                <form>
                  <input
                    value={this.state.message}
                    type="text"
                    onChange={this.handleChange}
                  />
                  <span>
                    <FontAwesomeIcon icon={['fas', 'images']} />
                  </span>
                  <button onClick={this.handleSubmit} ><FontAwesomeIcon icon={['fas', 'send']} /> Send</button>
                </form>
              </div>
            </div>
            <div className="user__List">
              <h4>In Lounge</h4>
              <ul>
                <li className="user__Item">
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/jonathan.png" />
                  <h5>Jonathan Cooper</h5>
                  <div className="socials">
                    <a href="mailto:jcooper@travpromobile.com">
                      <FontAwesomeIcon icon={['fas', 'envelope']} />
                    </a>
                    <a href="https://www.linkedin.com/in/jlcooper522/" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={['fab', 'linkedin']} />
                    </a>
                  </div>
                </li>
                <li className="user__Item">
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/frank.png" />
                  <h5>Frank Sillen</h5>
                  <div className="socials">
                    <a href="mailto:frank@travpromobile.com">
                      <FontAwesomeIcon icon={['fas', 'envelope']} />
                    </a>
                    <a href="https://www.linkedin.com/in/frank-sillen-3a21329" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={['fab', 'linkedin']} />
                    </a>
                  </div>
                </li>
                <li className="user__Item">
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/chris.png" />
                  <h5>Chris van Workum</h5>
                  <div className="socials">
                    <a href="mailto:chris@travpromobile.com">
                      <FontAwesomeIcon icon={['fas', 'envelope']} />
                    </a>
                    <a href="https://www.linkedin.com/in/chris-van-workum-90472b84" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={['fab', 'linkedin']} />
                    </a>
                  </div>
                </li>
                <li className="user__Item">
                  <img className="user__image" alt="user" src="https://travpromobile.com/images/jenn.png" />
                  <h5>Jennifer Belz</h5>
                  <div className="socials">
                    <a href="mailto:jbelz@travpromobile.com">
                      <FontAwesomeIcon icon={['fas', 'envelope']} />
                    </a>
                    <a href="https://www.linkedin.com/in/jennifer-belz-2a93463" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={['fab', 'linkedin']} />
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}
